module.exports = __webpack_public_path__ + "static/img/ai_bg.64d79c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ai_bg.png
// module id = vIVO
// module chunks = 129